<div class="modal-filter-calendar">
  <form class="container" [formGroup]="filterForm">
    <div class="filter-header">
      <p class="filter-title-header">Filtros</p>
      <button class="btn-close" (click)="closeFilter()">
        <img src="../../../assets/svgs/close_btn.svg" alt="Close">
      </button>
    </div>
    <div class="input-container">
      <app-input id="filter-calendar-key-event" formControlName="key_event" label="Palavra-chave incluída no evento" placeholder=""></app-input>
    </div>
    <div class="container-date">
      <label for="data-visit-time">Data da atividade</label>
      <div class="date-select">
        <lib-datepicker id="data-visti-from" placeholder=" - de"
          [date]="filterForm.get('date_from').value" 
          (dateChange)="filterForm.get('date_from').setValue($event)"
          format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>

        <lib-datepicker id="data-visti-to" placeholder=" - até"
          [date]="filterForm.get('date_to').value" 
          (dateChange)="filterForm.get('date_to').setValue($event)"
          format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
      </div>
    </div>
    <p class="search">Buscar em</p>
    <div class="list-checked">
      <lib-input-checkbox class="item-action" formControlName="event" id="events" name="events" label="Evento"></lib-input-checkbox>
      <lib-input-checkbox class="item-action" formControlName="task" id="task" name="task" label="Tarefa"></lib-input-checkbox>
      <lib-input-checkbox class="item-action" formControlName="remember" id="remember" name="remember" label="Lembrete"></lib-input-checkbox>
      <lib-input-checkbox class="item-action" formControlName="return" id="return" name="return" label="Retorno"></lib-input-checkbox>
      <lib-input-checkbox class="item-action" formControlName="visit" id="visit" name="visit" label="Visita"></lib-input-checkbox>
    </div>
    <div class="filter-footer">
      <lib-button-tertiary class="btn-cancel" id="btn-cancel-filter" (click)="clearForm()">Limpar tudo</lib-button-tertiary>
      <lib-button-primary id="btn-submited" [icon]="''" [maxWidth]="''" (click)="applyFilter()">Aplicar</lib-button-primary>
    </div>
  </form>
</div>